import { Controller } from 'stimulus'
import { roundMoney } from "@react/helpers/helpers"

export default class extends Controller {
  static targets = ['list', 'template', 'line', 'grandTotal']

  connect() {
    this.lineTargets.forEach(line => {
      this.recalculateLine(line)
      this.sizeDescription(line)
    })
    this.refresh()
  }

  add() {
    const html = this.templateTarget.innerHTML.replace(/NEW_LINE/g, `${Date.now()}`)
    this.listTarget.insertAdjacentHTML('beforeend', html)
    const line = this.lineTargets[this.lineTargets.length - 1]
    this.recalculateLine(line)
    this.refresh()
    this.field(line, 'description').focus()
  }

  remove(event) {
    const line = event.currentTarget.closest('[data-target~="purchase-invoices--lines.line"]')
    if (!line || this.visibleLines().length <= 1) return

    if (line.querySelector('input[name$="[id]"]')) {
      this.field(line, 'destroy').value = '1'
      line.classList.add('d-none')
      line.querySelectorAll('[required]').forEach(input => { input.required = false })
    } else {
      line.remove()
    }
    this.refresh()
  }

  autosize(event) {
    this.sizeDescription(event.currentTarget.closest('[data-target~="purchase-invoices--lines.line"]'))
  }

  sizeDescription(line) {
    const area = line && this.field(line, 'description')
    if (!area) return

    area.style.height = 'auto'
    area.style.height = `${Math.max(area.scrollHeight + 2, 42)}px`
  }

  recalculate(event) {
    const line = event.currentTarget.closest('[data-target~="purchase-invoices--lines.line"]')
    this.recalculateLine(line, true)
    this.refresh()
  }

  // Without a VAT rate the stated total stands until the line is edited, as on the server.
  recalculateLine(line, edited = false) {
    const subtotal   = parseFloat(this.field(line, 'subtotal').value) || 0
    const select     = this.field(line, 'vat_rate')
    const percentage = parseFloat(select.options[select.selectedIndex]?.dataset.percentage)
    const total      = this.field(line, 'total')

    if (!Number.isNaN(percentage)) {
      total.value = roundMoney(Math.round(subtotal * (100 + percentage)) / 100).toFixed(2)
    } else if (edited) {
      total.value = roundMoney(subtotal).toFixed(2)
    }
  }

  refresh() {
    this.lineTargets.forEach((line, index) => { this.field(line, 'order').value = index })

    const lines = this.visibleLines()
    lines.forEach((line, index) => {
      line.querySelector('.delete').classList.toggle('invisible', lines.length <= 1)

      // A line left empty is dropped on save; one that is started must be completed.
      const required = index === 0 || this.isFilled(line)
      this.field(line, 'subtotal').required = required
      this.field(line, 'vat_rate').required = required
    })

    if (!this.hasGrandTotalTarget) return

    const grandTotal = lines.reduce((sum, line) => sum + (parseFloat(this.field(line, 'total').value) || 0), 0)
    this.grandTotalTarget.textContent = this.formatMoney(roundMoney(grandTotal))
  }

  isFilled(line) {
    const description = this.field(line, 'description')?.value || ''
    return description.trim() !== '' || ['subtotal', 'vat_rate'].some(name => this.field(line, name).value !== '')
  }

  formatMoney(amount) {
    const locale = document.documentElement.lang || 'fr'
    return new Intl.NumberFormat(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount)
  }

  visibleLines() {
    return this.lineTargets.filter(line => !line.classList.contains('d-none'))
  }

  field(line, name) {
    return line.querySelector(`[data-line-field="${name}"]`)
  }
}
